import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const productGroupApiSlice = createApi({
	reducerPath: 'productGroupApi',
	baseQuery: fetchBaseQuery({ baseUrl: '/api/product-groups' }),
	tagTypes: ['ProductGroup'],
	endpoints: (builder) => ({
		getProductGroups: builder.query({
			query: () => '/',
			providesTags: (result) =>
				result
					? [
						...result.map(({ _id }) => ({ type: 'ProductGroup', id: _id })),
						{ type: 'ProductGroup', id: 'LIST' }
					]
					: [{ type: 'ProductGroup', id: 'LIST' }]
		}),
		getProductGroupById: builder.query({
			query: (id) => `/${id}`,
			providesTags: (result, error, id) => [{ type: 'ProductGroup', id }]
		}),
		createProductGroup: builder.mutation({
			query: (groupData) => ({
				url: '/',
				method: 'POST',
				body: groupData
			}),
			invalidatesTags: [{ type: 'ProductGroup', id: 'LIST' }]
		}),
		updateProductGroup: builder.mutation({
			query: ({ id, ...patch }) => ({
				url: `/${id}`,
				method: 'PUT',
				body: patch
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'ProductGroup', id }]
		}),
		patchProductGroup: builder.mutation({
			query: ({ id, ...patch }) => ({
				url: `/${id}`,
				method: 'PATCH',
				body: patch
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'ProductGroup', id }]
		}),
		deleteProductGroup: builder.mutation({
			query: (id) => ({
				url: `/${id}`,
				method: 'DELETE'
			}),
			invalidatesTags: (result, error, id) => [
				{ type: 'ProductGroup', id },
				{ type: 'ProductGroup', id: 'LIST' }
			]
		}),
		updateGroupAttributes: builder.mutation({
			query: ({ id, attributes }) => ({
				url: `/${id}/attributes`,
				method: 'PATCH',
				body: { attributes }
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'ProductGroup', id }]
		})
	})
});

export const {
	useGetProductGroupsQuery,
	useGetProductGroupByIdQuery,
	useCreateProductGroupMutation,
	useUpdateProductGroupMutation,
	usePatchProductGroupMutation,
	useDeleteProductGroupMutation,
	useUpdateGroupAttributesMutation
} = productGroupApiSlice;